import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { popupActions } from '../../../store/popupSlice';

const API_IMG_URL = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || '';

/**
 * Chuyển link banner nội bộ sang đường dẫn react-router.
 * - "/post/40" (tương đối)            → "/post/40"
 * - "https://longhousee.com/post/40"  → "/post/40"
 * - link ngoài domain                 → null (mở trình duyệt)
 */
function getInternalPath(url) {
    if (!url) return null;
    if (url.startsWith('/')) return url;
    try {
        const u = new URL(url);
        if (u.hostname.toLowerCase().endsWith('longhousee.com')) {
            return u.pathname + u.search + u.hash;
        }
    } catch {
        // URL không hợp lệ → bỏ qua
    }
    return null;
}

function GoToGuide() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const banner = useSelector((state) => state.popup.bannerData);

    const onClose = () => {
        dispatch(popupActions.closeGuide());
    };

    if (!banner) return null;

    const imgSrc = banner.imagePath?.startsWith('http')
        ? banner.imagePath
        : `${API_IMG_URL}${banner.imagePath}`;

    const isExternal = banner.linkType === 'external';
    const internalPath = isExternal ? null : getInternalPath(banner.linkUrl);

    // Link nội bộ → điều hướng react-router (không reload cả trang).
    const handleBannerClick = (e) => {
        if (internalPath) {
            e.preventDefault();
            onClose();
            navigate(internalPath);
        } else {
            onClose();
        }
    };

    const linkProps = isExternal
        ? { href: banner.linkUrl, target: '_blank', rel: 'noopener noreferrer' }
        : { href: banner.linkUrl };

    return (
        <div
            className="relative w-4/5 p-2 md:w-2/3 animate-zoomIn lg:w-1/3 flex flex-col justify-center items-center bg-surface rounded-lg shadow-lg border gap-2"
            onClick={(e) => e.stopPropagation()}
        >
            <div className="w-full">
                {banner.linkUrl ? (
                    <a {...linkProps} className="flex flex-col gap-2" onClick={handleBannerClick}>
                        <img src={imgSrc} alt={banner.title} className="rounded" />
                    </a>
                ) : (
                    <img src={imgSrc} alt={banner.title} className="rounded" />
                )}
            </div>
            <div
                onClick={onClose}
                className="absolute top-full right-1/2 translate-x-1/2 text-2xl mt-2 hover:text-content-3"
            >
                <FontAwesomeIcon icon={faXmark} className="pointer-events-none" />
            </div>
        </div>
    );
}

export default GoToGuide;
